import { alpha } from '@mui/material/styles';
const createGradient = (color1, color2)=>`linear-gradient(to bottom, ${color1}, ${color2})`;
const PRIMARY = {
    light: '#E9573D',
    main: '#C21B17',
    dark: '#8E1230',
    shades: {
        '8p': 'rgb(194 27 23 / 8%)',
        '12p': 'rgb(194 27 23 / 12%)',
        '16p': 'rgb(194 27 23 / 16%)',
        '30p': 'rgb(194 27 23 / 30%)',
        '50p': 'rgb(194 27 23 / 50%)',
        '160p': '#47110D',
        '190p': '#F6E9E8'
    }
};
const PRIMARY_DARK = {
    light: '#EE806C',
    main: '#E62D29',
    dark: '#BA183F',
    shades: {
        '8p': 'rgb(230 45 41 / 8%)',
        '12p': 'rgb(230 45 41 / 12%)',
        '16p': 'rgb(230 45 41 / 16%)',
        '30p': 'rgb(230 45 41 / 30%)',
        '50p': 'rgb(230 45 41 / 50%)',
        '160p': '#DDA7A4',
        '190p': '#110402'
    }
};
const SECONDARY = {
    light: '#F09273',
    main: '#D16944',
    dark: '#B15C49',
    shades: {
        '8p': 'rgb(209 105 68 / 8%)',
        '12p': 'rgb(209 105 68 / 12%)',
        '16p': 'rgb(209 105 68 / 16%)',
        '30p': 'rgb(209 105 68 / 30%)',
        '50p': 'rgb(209 105 68 / 50%)',
        '160p': '#4E2C1E',
        '190p': '#F8F0EC'
    }
};
const SECONDARY_DARK = {
    light: '#EDA991',
    main: '#DB896C',
    dark: '#B15C49',
    shades: {
        '8p': 'rgb(219 137 108 / 8%)',
        '12p': 'rgb(219 137 108 / 12%)',
        '16p': 'rgb(219 137 108 / 16%)',
        '30p': 'rgb(219 137 108 / 30%)',
        '50p': 'rgb(219 137 108 / 50%)',
        '160p': '#E6C4B6',
        '190p': '#140B08'
    }
};
const INFO = {
    light: '#7DA6CC',
    main: '#437EB5',
    dark: '#416586',
    shades: {
        '8p': 'rgb(67 126 181 / 8%)',
        '12p': 'rgb(67 126 181 / 12%)',
        '16p': 'rgb(67 126 181 / 16%)',
        '30p': 'rgb(67 126 181 / 30%)',
        '50p': 'rgb(67 126 181 / 50%)',
        '160p': '#1A3248',
        '190p': '#ECF2F8'
    }
};
const INFO_DARK = {
    light: '#57C4FF',
    main: '#07A6FD',
    dark: '#0166B6',
    shades: {
        '8p': 'rgb(7 166 253 / 8%)',
        '12p': 'rgb(7 166 253 / 12%)',
        '16p': 'rgb(7 166 253 / 16%)',
        '30p': 'rgb(7 166 253 / 30%)',
        '50p': 'rgb(7 166 253 / 50%)',
        '160p': '#9BDBFE',
        '190p': '#011119'
    }
};
const SUCCESS = {
    light: '#7BBE8A',
    main: '#55AB67',
    dark: '#4E7E58',
    shades: {
        '4p': 'rgb(85 171 103 / 4%)',
        '8p': 'rgb(85 171 103 / 8%)',
        '12p': 'rgb(85 171 103 / 12%)',
        '16p': 'rgb(85 171 103 / 16%)',
        '30p': 'rgb(85 171 103 / 30%)',
        '50p': 'rgb(85 171 103 / 50%)',
        '160p': '#214429',
        '190p': '#EEF7F0'
    }
};
const SUCCESS_DARK = {
    light: '#C4D27F',
    main: '#B7CB53',
    dark: '#87973B',
    shades: {
        '4p': 'rgb(183 203 83 / 4%)',
        '8p': 'rgb(183 203 83 / 8%)',
        '12p': 'rgb(183 203 83 / 12%)',
        '16p': 'rgb(183 203 83 / 16%)',
        '30p': 'rgb(183 203 83 / 30%)',
        '50p': 'rgb(183 203 83 / 50%)',
        '160p': '#E2EABA',
        '190p': '#121408'
    }
};
const WARNING = {
    light: '#FFC463',
    main: '#FF9F00',
    dark: '#B8760A',
    shades: {
        '8p': 'rgb(255 159 0 / 8%)',
        '12p': 'rgb(255 159 0 / 12%)',
        '16p': 'rgb(255 159 0 / 16%)',
        '30p': 'rgb(255 159 0 / 30%)',
        '50p': 'rgb(255 159 0 / 50%)',
        '160p': '#664001',
        '190p': '#FFF5E5'
    }
};
const WARNING_DARK = {
    light: '#FFC668',
    main: '#FFB233',
    dark: '#D0860B',
    shades: {
        '8p': 'rgb(255 178 51 / 8%)',
        '12p': 'rgb(255 178 51 / 12%)',
        '16p': 'rgb(255 178 51 / 16%)',
        '30p': 'rgb(255 178 51 / 30%)',
        '50p': 'rgb(255 178 51 / 50%)',
        '160p': '#FFE0AD',
        '190p': '#1A1205'
    }
};
const ERROR = {
    light: '#F39D8E',
    main: '#E9573D',
    dark: '#C73C23',
    shades: {
        '4p': 'rgb(233 87 61 / 4%)',
        '8p': 'rgb(233 87 61 / 8%)',
        '12p': 'rgb(233 87 61 / 12%)',
        '16p': 'rgb(233 87 61 / 16%)',
        '30p': 'rgb(233 87 61 / 30%)',
        '50p': 'rgb(233 87 61 / 50%)',
        '160p': '#5E2318',
        '190p': '#FDF0E6'
    }
};
const ERROR_DARK = {
    light: '#FFAA9B',
    main: '#EE806C',
    dark: '#DA452B',
    shades: {
        '4p': 'rgb(238 128 108 / 4%)',
        '8p': 'rgb(238 128 108 / 8%)',
        '12p': 'rgb(238 128 108 / 12%)',
        '16p': 'rgb(238 128 108 / 16%)',
        '30p': 'rgb(238 128 108 / 30%)',
        '50p': 'rgb(238 128 108 / 50%)',
        '160p': '#F9CCC4',
        '190p': '#180D0B'
    }
};
const UNDERWRITING = {
    light: '#C28EEB',
    main: '#B551E3',
    dark: '#8E3BCE',
    shades: {
        '8p': 'rgb(181 81 227 / 8%)',
        '12p': 'rgb(181 81 227 / 12%)',
        '16p': 'rgb(181 81 227 / 16%)',
        '30p': 'rgb(181 81 227 / 30%)',
        '50p': 'rgb(181 81 227 / 50%)',
        '160p': '#422458',
        '190p': '#f7EDFB'
    }
};
const UNDERWRITING_DARK = {
    light: '#D988FF',
    main: '#AE43E0',
    dark: '#9F23D9',
    shades: {
        '8p': 'rgb(174 67 224 / 8%)',
        '12p': 'rgb(174 67 224 / 12%)',
        '16p': 'rgb(174 67 224 / 16%)',
        '30p': 'rgb(174 67 224 / 30%)',
        '50p': 'rgb(174 67 224 / 50%)',
        '160p': '#d8b7ef',
        '190p': '#0f0915'
    }
};
const WHITE_COLOR = {
    main: '#FFFFFF',
    shades: {
        '12p': 'rgb(255 255 255 / 12%)',
        '60p': 'rgb(255 255 255 / 60%)'
    }
};
const GREY = {
    50: '#FAFAFA',
    92: '#EBEBEB',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#DFE0E1',
    400: '#BCBDBE',
    500: '#8D8E8F',
    600: '#737577',
    700: '#5F6163',
    800: '#3A3C3D',
    900: '#2F3031',
    A100: '#F5F5F5',
    A200: '#EEEEEE',
    A400: '#BCBDBE',
    A700: '#5F6163',
    // TODO - remove all 500_xx constants - please don't use
    500_8: alpha('#8D8E8F', 0.08),
    500_12: alpha('#8D8E8F', 0.12),
    500_16: alpha('#8D8E8F', 0.16),
    500_24: alpha('#8D8E8F', 0.24),
    500_32: alpha('#8D8E8F', 0.32),
    500_48: alpha('#8D8E8F', 0.48),
    500_56: alpha('#8D8E8F', 0.56),
    500_80: alpha('#8D8E8F', 0.8)
};
const BACKGROUND = {
    paper: '#FFFFFF',
    default: '#EBEBEB',
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#DFE0E1',
    neutral: GREY[200]
};
const BACKGROUND_DARK = {
    paper: '#2B3036',
    default: '#20252B',
    50: '#34393E',
    100: '#3B3F44',
    200: '#4A4E53',
    300: '#65696D',
    neutral: GREY[500_16]
};
const GRADIENTS = {
    primary: createGradient(PRIMARY.light, PRIMARY.main),
    info: createGradient(INFO.light, INFO.main),
    success: createGradient(SUCCESS.light, SUCCESS.main),
    warning: createGradient(WARNING.light, WARNING.main),
    error: createGradient(ERROR.light, ERROR.main)
};
const GRADIENTS_DARK = {
    primary: createGradient(PRIMARY_DARK.light, PRIMARY_DARK.main),
    info: createGradient(INFO_DARK.light, INFO_DARK.main),
    success: createGradient(SUCCESS_DARK.light, SUCCESS_DARK.main),
    warning: createGradient(WARNING_DARK.light, WARNING_DARK.main),
    error: createGradient(ERROR_DARK.light, ERROR_DARK.main)
};
const CHART_COLORS = {
    violet: [
        '#826AF9',
        '#9E86FF',
        '#D0AEFF',
        '#F7D2FF'
    ],
    blue: [
        '#2D99FF',
        '#83CFFF',
        '#A5F3FF',
        '#CCFAFF'
    ],
    green: [
        '#2CD9C5',
        '#60F1C8',
        '#A4F7CC',
        '#C0F2DC'
    ],
    yellow: [
        '#FFE700',
        '#FFEF5A',
        '#FFF7AE',
        '#FFF3D6'
    ],
    red: [
        '#FF6C40',
        '#FF8F6D',
        '#FFBD98',
        '#FFF2D4'
    ]
};
const OTHER = {
    backdrop: 'rgba(0, 0, 0, 0.5)',
    fieldTooltip: '#737577'
};
const OTHER_DARK = {
    backdrop: 'rgba(0, 0, 0, 0.5)',
    fieldTooltip: '#5C6064'
};
const LIGHT = {
    common: {
        black: '#000',
        white: '#fff'
    },
    primary: {
        ...PRIMARY,
        contrastText: '#fff'
    },
    secondary: {
        ...SECONDARY,
        contrastText: '#fff'
    },
    info: {
        ...INFO,
        contrastText: '#fff'
    },
    success: {
        ...SUCCESS,
        contrastText: '#fff'
    },
    warning: {
        ...WARNING,
        contrastText: '#fff'
    },
    error: {
        ...ERROR,
        contrastText: '#fff'
    },
    underwriting: {
        ...UNDERWRITING,
        contrastText: '#fff'
    },
    grey: GREY,
    background: BACKGROUND,
    white: WHITE_COLOR,
    gradients: GRADIENTS,
    chart: CHART_COLORS,
    divider: 'rgba(0,0,0,0.12)',
    other: OTHER,
    action: {
        hover: GREY[500_8],
        selected: GREY[500_16],
        disabled: GREY[500_80],
        disabledBackground: GREY[500_24],
        focus: GREY[500_24],
        hoverOpacity: 0.08,
        disabledOpacity: 0.48
    }
};
const DARK = {
    common: {
        black: '#000',
        white: '#fff'
    },
    primary: {
        ...PRIMARY_DARK,
        contrastText: '#fff'
    },
    secondary: {
        ...SECONDARY_DARK,
        contrastText: '#fff'
    },
    info: {
        ...INFO_DARK,
        contrastText: '#fff'
    },
    success: {
        ...SUCCESS_DARK,
        contrastText: '#fff'
    },
    warning: {
        ...WARNING_DARK,
        contrastText: '#fff'
    },
    error: {
        ...ERROR_DARK,
        contrastText: '#fff'
    },
    underwriting: {
        ...UNDERWRITING_DARK,
        contrastText: '#fff'
    },
    grey: GREY,
    background: BACKGROUND_DARK,
    white: WHITE_COLOR,
    gradients: GRADIENTS_DARK,
    chart: CHART_COLORS,
    divider: 'rgba(255,255,255,0.12)',
    other: OTHER_DARK,
    action: {
        hover: GREY[500_8],
        selected: GREY[500_16],
        disabled: GREY[500_80],
        disabledBackground: GREY[500_24],
        focus: GREY[500_24],
        hoverOpacity: 0.08,
        disabledOpacity: 0.48
    }
};
const palette = {
    light: {
        ...LIGHT,
        mode: 'light',
        text: {
            primary: '#20252B',
            secondary: alpha('#20252B', 0.7),
            disabled: alpha('#20252B', 0.38)
        },
        action: {
            active: GREY[600],
            ...LIGHT.action
        }
    },
    dark: {
        ...DARK,
        mode: 'dark',
        text: {
            primary: '#fff',
            secondary: alpha('#fff', 0.7),
            disabled: alpha('#fff', 0.5)
        },
        action: {
            active: GREY[500],
            ...DARK.action
        }
    }
};
export default palette;
